
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 631"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Visa')]),_c('path',{attrs:{"fill":"#fff","d":"M0 0h1000v631H0z"}}),_c('path',{attrs:{"fill":"#00579f","d":"M422.666 450.649H353l43.574-269.43h69.662l-43.57 269.43zM675.211 187.806a171.685 171.685 0 00-62.485-11.47c-68.797 0-117.244 36.686-117.54 89.136-.572 38.698 34.686 60.192 61.056 73.095 26.952 13.185 36.115 21.79 36.115 33.543-.275 18.05-21.78 26.37-41.837 26.37-27.814 0-42.717-4.29-65.365-14.331l-9.174-4.305-9.749 60.481c16.34 7.444 46.443 14.05 77.697 14.34 73.098 0 120.688-36.12 121.252-92.014.278-30.67-18.34-54.172-58.478-73.376-24.366-12.328-39.288-20.64-39.288-33.254.286-11.467 12.621-23.212 40.127-23.212a118.365 118.365 0 0151.894 10.316l6.3 2.861 9.475-58.18zM767.803 355.2c5.738-15.479 27.814-75.385 27.814-75.385-.29.576 5.726-15.764 9.166-25.794l4.869 23.215s13.192 64.493 16.057 77.964zm85.994-173.98h-53.886c-16.618 0-29.243 4.868-36.412 22.354l-103.48 247.071h73.098s12.035-33.254 14.621-40.416h89.446c2 9.46 8.312 40.416 8.312 40.416H910L853.797 181.22zM294.812 181.22l-68.226 183.725-7.455-37.262c-12.614-42.995-52.172-89.708-96.318-112.935l62.493 235.615h73.67L368.477 181.22h-73.666z"}}),_c('path',{attrs:{"d":"M163.233 181.22H51.147L50 186.662c87.434 22.359 145.34 76.253 169.13 141.031l-24.365-123.827c-4.012-17.207-16.34-22.08-31.532-22.648z","fill":"#faa61a"}})])
          )
        }
      }
    